export default {
    close: 'Zatvoriť',
    dataIterator: {
      pageText: '{0}-{1} z {2}',
      noResultsText: 'Neboli nájdene žiadne vyhovujúce záznamy',
      loadingText: 'Načítavam položky...',
    },
    dataTable: {
      itemsPerPageText: 'Záznamov:',
      ariaLabel: {
        sortDescending: ': Zoradené klesajúco. Aktivujte na zrušenie zoradenia.',
        sortAscending: ': Zoradené stúpajúco. Aktivujte na zoradenie klesajúco.',
        sortNone: ': Nezoradené. Aktivujte na zoradenie stúpajúco.',
      },
      sortBy: 'Zoradiť podľa',
    },
    dataFooter: {
      itemsPerPageText: 'Položiek na stranu:',
      itemsPerPageAll: 'Všetko',
      nextPage: 'Ďalšia strana',
      prevPage: 'Predchádzajúca strana',
      firstPage: 'Prvá strana',
      lastPage: 'Posledná strana',
    },
    datePicker: {
      itemsSelected: '{0} vybrané',
    },
    noDataText: 'Žiadne dáta dostupné',
    carousel: {
      prev: 'Predchádzajúci náhľad',
      next: 'Ďalší náhľad',
    },
    calendar: {
      moreEvents: '{0} viac',
    },
    fileInput: {
      counter: '{0} súborov',
      counterSize: '{0} súborov ({1} celkovo)',
    },
  }
  